// Cart Drawer Personal - UI-specific functions for cart drawer

// UI-specific function to open cart drawer
function openCart(shouldDelay = false) {
  try {
    const cartDrawer = document.getElementById('cart-drawer-personal');
    if (cartDrawer) {
      const openCartAction = () => {
        cartDrawer.classList.add('open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        
        // Update cart content when opened with animation
        updateCartDrawerContent(true);
        
        // Check for open_discount setting and auto-open discount section
        checkAndAutoOpenDiscountSection();
        
        console.log('✅ Cart drawer opened');
      };
      
      if (shouldDelay) {
        setTimeout(openCartAction, 1000); // 0.3s delay
      } else {
        openCartAction();
      }
    } else {
      console.warn('Cart drawer element not found');
    }
  } catch (error) {
    console.error('❌ Error opening cart drawer:', error);
  }
}

// UI-specific function to close cart drawer
function closeCart() {
  try {
    const cartDrawer = document.getElementById('cart-drawer-personal');
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      
      // Wait for animation to complete before restoring scroll
      setTimeout(() => {
        document.body.style.overflow = ''; // Restore background scrolling
      }, 400); // Match the CSS transition duration
      
      console.log('✅ Cart drawer closed');
    }
  } catch (error) {
    console.error('❌ Error closing cart drawer:', error);
  }
}

// UI-specific function to update cart drawer content
async function updateCartDrawerContent(shouldAnimate = false) {
  try {
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const supplements = Object.keys(currentSupplementCart);
    
    const cartItemsContainer = document.getElementById('cart-items-container');
    const cartEmptyState = document.getElementById('cart-empty-state');
    const cartSupplementList = document.getElementById('cart-supplement-list');
    
    if (supplements.length === 0) {
      // Show empty state
      if (cartEmptyState) cartEmptyState.style.display = 'flex';
      if (cartItemsContainer) cartItemsContainer.style.display = 'none';
    } else {
      // Show cart items
      if (cartEmptyState) cartEmptyState.style.display = 'none';
      if (cartItemsContainer) cartItemsContainer.style.display = 'block';
      
      // Update supplement list
      if (cartSupplementList) {
        cartSupplementList.innerHTML = '';
        
        supplements.forEach(supplementName => {
          const supplementData = fetchDataSupplement[supplementName];
          if (supplementData) {
            const supplementItem = createSupplementCartItem(supplementName, supplementData, shouldAnimate);
            cartSupplementList.appendChild(supplementItem);
          }
        });
      }
    }
    
    // Update add more supplements list
    updateAddMoreSupplementsList();
    
    // Check and display applied discounts from localStorage
    displayAppliedDiscountsFromStorage();
    
    // Update cart summary and shipping progress
    updateCartSummary();
    await updateShippingProgress();
    
  } catch (error) {
    console.error('❌ Error updating cart drawer content:', error);
  }
}

// UI-specific function to create supplement cart item
function createSupplementCartItem(supplementName, supplementData, shouldAnimate = false) {
  const item = document.createElement('div');
  item.className = shouldAnimate ? 'cdp-cart-supplement-item slide-in' : 'cdp-cart-supplement-item';
  
  // Get supplement image from global data
  let supplementImage = 'https://via.placeholder.com/48';
  if (typeof pills_floating !== 'undefined' && pills_floating[supplementName]) {
    supplementImage = pills_floating[supplementName];
  } else if (supplementData && supplementData.image) {
    supplementImage = supplementData.image;
  }
  
  // Get supplement dosage info
  let dosageInfo = 'Health supplement';
  if (typeof doses !== 'undefined' && typeof unit !== 'undefined' && typeof numberOfCapsules !== 'undefined') {
    if (doses[supplementName] && unit[supplementName] && numberOfCapsules[supplementName]) {
      dosageInfo = `${doses[supplementName]}${unit[supplementName]} · ${numberOfCapsules[supplementName]}`;
    }
  }
  
  // Get supplement benefits/tags
  let benefitsText = 'Health supplement';
  if (typeof supplementToGoalsL1L2_very_short !== 'undefined' && supplementToGoalsL1L2_very_short[supplementName]) {
    benefitsText = supplementToGoalsL1L2_very_short[supplementName].slice(0, 2).join(', ');
  } else if (supplementData && supplementData.benefits) {
    benefitsText = supplementData.benefits.slice(0, 2).join(', ');
  }
  
  // Get current currency and price
  let currencyCode = 'SGD';
  if (window.Shopify && Shopify.currency && Shopify.currency.active) {
    currencyCode = Shopify.currency.active;
  }
  
  const price = getFormattedPrice(supplementName, false, currencyCode);
  const formattedPrice = formatWithCurrency(window.Shopify?.currency, price.value.toFixed(2));

  item.innerHTML = `
    <div class="cdp-supplement-left-container">
      <img src="${supplementImage}" 
          alt="${supplementName}" 
          class="cdp-supplement-image">
      
      <div class="cdp-supplement-info">
        <h4 class="cdp-supplement-name body-semibold-black font-16px">${supplementName}</h4>
        <p class="cdp-supplement-dosage body-medium-grey font-14px">30 servings</p>
        <p class="cdp-supplement-benefits body-medium-lightgrey font-14px">${dosageInfo}</p>
      </div>
    </div>
    
    <div class="cdp-supplement-actions">
      <button class="cdp-remove-supplement" onclick="removeSupplementFromCartDrawer('${supplementName}')">
        <svg class="cross-icon" viewBox="0 0 24 24">
          <path d="M18 6L6 18M6 6l12 12" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"/>
        </svg>
      </button>
      
      <div class="cdp-supplement-price">
        <div class="cdp-price-amount body-semibold-black font-18px">${formattedPrice}</div>
        <div class="cdp-price-period body-medium-lightgrey font-10px">per month</div>
      </div>
    </div>
  `;
  
  return item;
}

// UI-specific function to remove supplement from cart drawer
function removeSupplementFromCartDrawer(supplementName) {
  try {
    const removeButton = event.target.closest('.cdp-remove-supplement');
    if (removeButton) {
      removeButton.disabled = true;
      removeButton.innerHTML = '<div style="display:block !important; width: 18px; height: 18px; border: 2px solid #ccc; border-top: 2px solid #1d1d1d; border-radius: 50%; animation: spin 1s linear infinite;"></div>';
    }
    
    // Set up one-time event listener to wait for cart change
    const handleCartRemoval = () => {
      console.log('📢 Cart drawer received removal confirmation');
      
      // Update cart drawer content without animation
      updateCartDrawerContent(false);
      
      // Update cart icon
      updateCartIconVisibility();
      
      // Remove this event listener after handling
      window.removeEventListener('cartChangedDelayed', handleCartRemoval);
    };
    
    // Add event listener for cart change
    window.addEventListener('cartChangedDelayed', handleCartRemoval);
    
    // Trigger removal (don't await - let the event handle the UI update)
    globalRemoveSupplementFromCart(supplementName).catch(error => {
      console.error('❌ Error removing supplement from cart drawer:', error);
      
      // Remove the event listener on error
      window.removeEventListener('cartChangedDelayed', handleCartRemoval);
      
      // Reset button state on error
      const removeButton = event.target.closest('.cdp-remove-supplement');
      if (removeButton) {
        removeButton.disabled = false;
        removeButton.innerHTML = `
          <svg class="cross-icon" viewBox="0 0 24 24">
            <path d="M18 6L6 18M6 6l12 12" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
          </svg>
        `;
      }
    });
    
  } catch (error) {
    console.error('❌ Error setting up supplement removal:', error);
  }
}

// UI-specific function to apply discount from cart drawer
async function applyCartDiscount() {
  try {
    const discountInput = document.getElementById('cart-discount-input');
    const applyButton = document.getElementById('cart-apply-discount');
    
    if (!discountInput || !applyButton) return;
    
    const discountCode = discountInput.value.trim();
    if (!discountCode) return;
    
    // Apply discount using global function
    const result = await globalAddDiscount(discountCode, applyButton, "Checking...", "Applied", "Invalid", "Applied");
    
    if (result.success) {
      // Clear input on success
      discountInput.value = '';
      
      // Update applied discounts display
      updateAppliedDiscounts();
      
      // Show success message if discount was replaced
      if (result.replaced) {
        showDiscountSuccess(`Discount upgraded! Replaced ${result.replaced} with ${discountCode}`);
      }
    } else {
      // Handle different error types with specific messages
      if (result.error === 'CANNOT_COMBINE') {
        showDiscountError(result.message, 'warning'); // Different styling for combination errors
      } else {
        showDiscountError(result.message, 'error'); // Standard error styling for invalid codes
      }
    }
    
    // Always refresh everything after discount action
    updateCartSummary();
    await updateShippingProgress();
    
  } catch (error) {
    console.error('❌ Error applying cart discount:', error);
  }
}

// UI-specific function to remove applied discount
async function removeAppliedDiscount(discountCode, buttonElement) {
  try {
    // Call global remove function
    const result = await globalRemoveAppliedDiscount(discountCode);
    
    if (result.success) {
      // Remove from UI
      const discountItem = buttonElement.closest('.cdp-applied-discount-item');
      if (discountItem) {
        discountItem.remove();
      }
      
      // Recompute discount content height after removal
      recomputeDiscountContentHeight();
      
      // Update discount count bubble
      updateDiscountCountBubble();
      
      // Update the display
      updateCartSummary();
      await updateShippingProgress();
    }
    
  } catch (error) {
    console.error('❌ Error removing applied discount:', error);
  }
}

// UI-specific function to go to checkout from cart drawer
async function goToCheckout() {
  try {
    const checkoutButton = document.querySelector('.cdp-cart-checkout-btn');
    const checkoutBtnText = document.getElementById('checkout-btn-text');
    
    // Call global checkout function with button element and processing text
    const result = await globalGoToCheckout({
      onSuccess: () => {
        console.log('✅ Checkout initiated successfully');
      },
      onError: (error) => {
        // Show specific error message
        const errorMessage = error.message || 'There was an error processing your checkout. Please try again.';
        alert(errorMessage);
        console.error('Checkout error details:', error);
      }
    }, checkoutButton, 'Processing...');
    
  } catch (error) {
    console.error('❌ Error during checkout:', error);
    alert('There was an error processing your checkout. Please try again.');
  }
}

// UI-specific function to display applied discounts from localStorage
function displayAppliedDiscountsFromStorage() {
  try {
    // Use the new updateAppliedDiscounts function
    updateAppliedDiscounts();
    
  } catch (error) {
    console.error('❌ Error displaying applied discounts:', error);
  }
}

// UI-specific function to update cart summary
function updateCartSummary() {
  try {
    let currencyCode = "SGD";
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Get cart calculations from global function
    const cartCalculations = globalCalculateCartTotals();
    
    // Get current supplement cart to count items
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const supplementCount = Object.keys(currentSupplementCart).length;
    
    // Update DOM elements
    const cartSubtotalLabel = document.getElementById('cart-subtotal-label');
    const cartSubtotal = document.getElementById('cart-subtotal');
    const cartOriginalSubtotal = document.getElementById('cart-original-subtotal');
    
    // Update subtotal label with item count
    if (cartSubtotalLabel) {
      cartSubtotalLabel.textContent = `Subtotal (${supplementCount} item${supplementCount !== 1 ? 's' : ''})`;
    }
    
    // Update cart item count in header
    updateCartItemCount(supplementCount);
    
    // Update subtotal prices
    if (cartSubtotal) {
      const subtotal = cartCalculations.subtotal -  cartCalculations.totalDiscountAmount;
      cartSubtotal.textContent = formatWithCurrency(window.Shopify?.currency, subtotal.toFixed(2));
    }
    
    // Show original price if there's a discount
    if (cartOriginalSubtotal) {
      if (cartCalculations.totalDiscountAmount > 0) {
        const originalSubtotal = cartCalculations.subtotal;
        cartOriginalSubtotal.textContent = formatWithCurrency(window.Shopify?.currency, originalSubtotal.toFixed(2));
        cartOriginalSubtotal.style.display = 'block';
      } else {
        cartOriginalSubtotal.style.display = 'none';
      }
    }
    
    console.log('📊 Cart Summary Updated:', cartCalculations);
    
  } catch (error) {
    console.error('❌ Error updating cart summary:', error);
  }
}

// UI-specific function to update shipping progress
async function updateShippingProgress() {
  try {
    let currencyCode = "SGD";
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Get shipping calculations from global function
    const shippingCalculations = globalCalculateShippingProgress(currencyCode);
    
    const progressElement = document.getElementById('shipping-progress-fill');
    const progressTextElement = document.getElementById('shipping-progress-text');
    const amountNeededElement = document.getElementById('amount-needed-shipping');
    
    // Update progress bar
    if (progressElement) {
      progressElement.style.width = `${shippingCalculations.progressPercentage}%`;
    }
    
    // Update progress text
    if (progressTextElement) {
      if (shippingCalculations.freeShippingAchieved) {
        progressTextElement.innerHTML = `<span>You've unlocked FREE shipping!</span>`;
      } else {
        progressTextElement.innerHTML = `Spend <span id="amount-needed-shipping">${shippingCalculations.amountNeededFormatted}</span> to unlock FREE shipping!`;
      }
    }
    
    if (amountNeededElement && !shippingCalculations.freeShippingAchieved) {
      amountNeededElement.textContent = shippingCalculations.amountNeededFormatted;
    }
    
  } catch (error) {
    console.error('❌ Error updating shipping progress:', error);
  }
}

// UI-specific helper functions for messages
function showDiscountError(message, type = 'error') {
  // Create or update error message element
  let errorElement = document.getElementById('discount-error-message');
  
  if (!errorElement) {
    errorElement = document.createElement('div');
    errorElement.id = 'discount-error-message';
    
    const discountSection = document.querySelector('.cdp-discount-section');
    if (discountSection) {
      discountSection.appendChild(errorElement);
    }
  }
  
  // Set different styling based on error type
  if (type === 'warning') {
    errorElement.className = 'cdp-discount-warning';
  } else {
    errorElement.className = 'cdp-discount-error';
  }
  
  errorElement.textContent = message;
  errorElement.style.display = 'block';
  
  // Auto-hide error after 6 seconds for warnings, 4 seconds for errors
  const hideTimeout = type === 'warning' ? 6000 : 4000;
  setTimeout(() => {
    if (errorElement) {
      errorElement.style.display = 'none';
    }
  }, hideTimeout);
}

function showDiscountSuccess(message) {
  // Create or update success message element
  let successElement = document.getElementById('discount-success-message');
  
  if (!successElement) {
    successElement = document.createElement('div');
    successElement.id = 'discount-success-message';
    successElement.className = 'cdp-discount-success';
    
    const discountSection = document.querySelector('.cdp-discount-section');
    if (discountSection) {
      discountSection.appendChild(successElement);
    }
  }
  
  successElement.textContent = message;
  successElement.style.display = 'block';
  
  // Auto-hide success after 3 seconds
  setTimeout(() => {
    if (successElement) {
      successElement.style.display = 'none';
    }
  }, 3000);
}

// UI-specific function to toggle discount section accordion
function toggleDiscountSection() {
  try {
    const discountSection = document.querySelector('.cdp-discount-section');
    const discountContent = document.querySelector('.cdp-discount-content');
    const chevronToUp = discountSection?.querySelector('.chevron-to-up');
    const chevronToDown = discountSection?.querySelector('.chevron-to-down');
    
    if (!discountSection || !discountContent) return;
    
    const isActive = discountSection.classList.contains('active');
    
    if (isActive) {
      // Close
      discountSection.classList.remove('active');
      discountContent.style.maxHeight = '0px';
      if (chevronToDown) chevronToDown.beginElement();
    } else {
      // Open
      discountSection.classList.add('active');
      discountContent.style.maxHeight = discountContent.scrollHeight + 'px';
      if (chevronToUp) chevronToUp.beginElement();
    }
    
  } catch (error) {
    console.error('❌ Error toggling discount section:', error);
  }
}

// UI-specific function to update add more supplements list
function updateAddMoreSupplementsList() {
  try {
    const addMoreList = document.getElementById('add-more-supplements-list');
    if (!addMoreList) return;
    
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const currentSupplements = Object.keys(currentSupplementCart);
    
    // Get all available supplements (excluding those already in cart)
    const availableSupplements = [];
    if (typeof fetchDataSupplement !== 'undefined') {
      Object.keys(fetchDataSupplement).forEach(supplementName => {
        if (!currentSupplements.includes(supplementName)) {
          availableSupplements.push(supplementName);
        }
      });
    }
    
    // Clear existing list
    addMoreList.innerHTML = '';
    
    // Add supplement cards
    availableSupplements.slice(0, 10).forEach(supplementName => { // Limit to 10 for performance
      const supplementData = fetchDataSupplement[supplementName];
      if (supplementData) {
        const supplementCard = createAddMoreSupplementCard(supplementName, supplementData);
        addMoreList.appendChild(supplementCard);
      }
    });
    
  } catch (error) {
    console.error('❌ Error updating add more supplements list:', error);
  }
}

// UI-specific function to create add more supplement card
function createAddMoreSupplementCard(supplementName, supplementData) {
  const card = document.createElement('div');
  card.className = 'cdp-add-more-item card-internal-shadow';
  
  // Get supplement image
  let supplementImage = 'https://via.placeholder.com/24';
  
  if (typeof pills_floating !== 'undefined' && pills_floating[supplementName]) {
    supplementImage = pills_floating[supplementName];
  } else if (supplementData && supplementData.image) {
    supplementImage = supplementData.image;
  }
  
  // Get current currency
  let currencyCode = 'SGD';
  if (window.Shopify && Shopify.currency && Shopify.currency.active) {
    currencyCode = Shopify.currency.active;
  }
  
  // Get supplement price using the same logic as supplement grid
  const price = getFormattedPrice(supplementName, false, currencyCode);
  
  card.innerHTML = `
    <img src="${supplementImage}" alt="${supplementName}" class="cdp-add-more-item-icon">
    <div class="cdp-add-more-item-info">
      <h4 class="cdp-add-more-item-name body-semibold-black font-16px">${supplementName}</h4>
      <div class="cdp-add-more-item-price body-semibold-black font-16px">
        <span class="currency">${price.prefix}</span>
        <span class="amount">${price.value}</span>
        <span class="cents ${currencyCode}" style="display: ${currencyCode === 'IDR' ? 'inline' : 'none'}">${price.suffix}</span>
      </div>
    </div>
    <button class="cdp-add-more-item-btn secondary-button" onclick="addSupplementToCartFromDrawer('${supplementName}')">
      + Add
    </button>
  `;
  
  return card;
}

// UI-specific function to add supplement to cart from drawer
async function addSupplementToCartFromDrawer(supplementName) {
  let addButton = null;
  
  try {
    addButton = event.target;
    if (addButton) {
      addButton.disabled = true;
      // Show spinning animation instead of text
      addButton.innerHTML = '<div style="display:block !important; width: 16px; height: 16px; border: 2px solid #ccc; border-top: 2px solid #1d1d1d; border-radius: 50%; animation: spin 1s linear infinite;"></div>';
    }
    
    // Set up one-time event listener to wait for cart change
    const handleCartAddition = () => {
      console.log('📢 Cart drawer received addition confirmation');
      
      // Update cart drawer content without animation
      updateCartDrawerContent(false);
      
      // Update cart icon
      updateCartIconVisibility();
      
      // Reset button state
      if (addButton) {
        addButton.disabled = false;
        addButton.innerHTML = '+ Add';
      }
      
      // Remove this event listener after handling
      window.removeEventListener('cartChangedDelayed', handleCartAddition);
    };
    
    // Add event listener for cart change
    window.addEventListener('cartChangedDelayed', handleCartAddition);
    
    // Call global add function (doesn't return a result object)
    await globalAddSupplementToCart(
      supplementName,
      null,
      "Adding...",
      "Added to Stack",
      "addToCartFromDrawer",
      false // Don't open cart since we're already in the drawer
    );
    
  } catch (error) {
    console.error('❌ Error adding supplement to cart from drawer:', error);
    
    // Remove the event listener on error
    window.removeEventListener('cartChangedDelayed', handleCartAddition);
    
    // Reset button state on error
    if (addButton) {
      addButton.disabled = false;
      addButton.innerHTML = '+ Add';
    }
  }
}

// UI-specific function to scroll supplements horizontally
function scrollSupplements(direction) {
  try {
    const addMoreList = document.getElementById('add-more-supplements-list');
    if (!addMoreList) return;
    
    const scrollAmount = 160; // Width of one card + gap
    const currentScroll = addMoreList.scrollLeft;
    
    if (direction === 'left') {
      addMoreList.scrollTo({
        left: currentScroll - scrollAmount,
        behavior: 'smooth'
      });
    } else if (direction === 'right') {
      addMoreList.scrollTo({
        left: currentScroll + scrollAmount,
        behavior: 'smooth'
      });
    }
    
  } catch (error) {
    console.error('❌ Error scrolling supplements:', error);
  }
}

// UI-specific function to update cart item count in header
function updateCartItemCount(supplementCount) {
  try {
    const cartItemCountElement = document.getElementById('cart-item-count');
    if (!cartItemCountElement) return;
    
    if (supplementCount === 0) {
      cartItemCountElement.textContent = 'Your cart is empty';
    } else {
      cartItemCountElement.textContent = `${supplementCount} item${supplementCount !== 1 ? 's' : ''} in your cart`;
    }
    
  } catch (error) {
    console.error('❌ Error updating cart item count:', error);
  }
}

// UI-specific function to update applied discounts display
function updateAppliedDiscounts() {
  try {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    if (!appliedDiscountsContainer) return;
    
    // Get applied discounts from localStorage
    const appliedDiscounts = getAppliedDiscounts();
    const discountCodes = Object.keys(appliedDiscounts);
    
    // Clear existing discounts
    appliedDiscountsContainer.innerHTML = '';
    
    // Add each applied discount
    discountCodes.forEach(discountCode => {
      const discount = appliedDiscounts[discountCode];
      const discountItem = document.createElement('div');
      discountItem.className = 'cdp-applied-discount-item';
      discountItem.setAttribute('data-discount-code', discountCode);
      
      // Format discount display text with amount/percentage
      let discountDisplay = discountCode;
      
      if (discount.type === 'shipping') {
        discountDisplay = `${discountCode} (Free Shipping)`;
      } else if (discount.type === 'line_item') {
        if (discount.valueType === 'fixed_amount') {
          const savings = formatWithCurrency(window.Shopify?.currency, discount.value.toFixed(2));
          discountDisplay = `${discountCode} (-${savings})`;
        } else if (discount.valueType === 'percentage') {
          discountDisplay = `${discountCode} (-${discount.value}%)`;
        }
      }
      
      // Use title if available and different from code
      if (discount.title && discount.title !== discountCode) {
        if (discount.type === 'shipping') {
          discountDisplay = `${discount.title} (Free Shipping)`;
        } else if (discount.type === 'line_item') {
          if (discount.valueType === 'fixed_amount') {
            const savings = formatWithCurrency(window.Shopify?.currency, discount.value.toFixed(2));
            discountDisplay = `${discount.title} (-${savings})`;
          } else if (discount.valueType === 'percentage') {
            discountDisplay = `${discount.title} (-${discount.value}%)`;
          }
        }
      }
      
      discountItem.innerHTML = `
        <div class="cdp-discount-code">
          <i data-lucide="tag" class="icon"></i>
          <span class="cdp-discount-text body-medium-black font-16px">${discountDisplay}</span>
        </div>
        <button class="cdp-remove-discount" onclick="removeAppliedDiscount('${discountCode}', this)">
          <i data-lucide="x" class="icon"></i>
        </button>
      `;
      
      appliedDiscountsContainer.appendChild(discountItem);
    });
    
    // Initialize Lucide icons for new elements
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      lucide.createIcons();
    }
    
    // Recompute max-height of discount content to show applied discounts
    recomputeDiscountContentHeight();
    
    // Update discount count bubble
    updateDiscountCountBubble();
    
    console.log('✅ Applied discounts updated:', discountCodes);
    
  } catch (error) {
    console.error('❌ Error updating applied discounts:', error);
  }
}

// UI-specific function to recompute discount content height
function recomputeDiscountContentHeight() {
  try {
    const discountSection = document.querySelector('.cdp-discount-section');
    const discountContent = document.querySelector('.cdp-discount-content');
    
    if (!discountSection || !discountContent) return;
    
    // Only recompute if the section is active (open)
    if (discountSection.classList.contains('active')) {
      // Temporarily set max-height to auto to measure content
      discountContent.style.maxHeight = 'auto';
      const contentHeight = discountContent.scrollHeight;
      
      // Set the new max-height
      discountContent.style.maxHeight = contentHeight + 'px';
      
      console.log('✅ Discount content height recomputed:', contentHeight + 'px');
    }
    
  } catch (error) {
    console.error('❌ Error recomputing discount content height:', error);
  }
}

// UI-specific function to update discount count bubble
function updateDiscountCountBubble() {
  try {
    const discountCountBubble = document.getElementById('discount-count-bubble');
    const discountCountNumber = document.getElementById('discount-count-number');
    
    if (!discountCountBubble || !discountCountNumber) return;
    
    // Get applied discounts from localStorage
    const appliedDiscounts = getAppliedDiscounts();
    const discountCount = Object.keys(appliedDiscounts).length;
    
    if (discountCount > 0) {
      // Show bubble and update number
      discountCountBubble.style.display = 'flex';
      discountCountNumber.textContent = discountCount;
    } else {
      // Hide bubble when no discounts
      discountCountBubble.style.display = 'none';
    }
    
    console.log('✅ Discount count bubble updated:', discountCount);
    
  } catch (error) {
    console.error('❌ Error updating discount count bubble:', error);
  }
}

// UI-specific function to check and auto-open discount section
function checkAndAutoOpenDiscountSection() {
  try {
    // Check if open_discount setting exists in localStorage
    const openDiscountSetting = localStorage.getItem('open_discount');
    
    if (openDiscountSetting === 'true') {
      console.log('📝 Found open_discount setting, will auto-open discount section in 2 seconds');
      
      // Set a 2-second timer to open the discount section
      setTimeout(() => {
        try {
          // Check if discount section is not already open
          const discountSection = document.querySelector('.cdp-discount-section');
          if (discountSection && !discountSection.classList.contains('active')) {
            // Open the discount section
            toggleDiscountSection();
            console.log('✅ Auto-opened discount section');
          }
          
          // Remove the setting from localStorage after opening
          localStorage.removeItem('open_discount');
          console.log('🗑️ Removed open_discount setting from localStorage');
          
        } catch (error) {
          console.error('❌ Error auto-opening discount section:', error);
          // Still remove the setting even if there was an error
          localStorage.removeItem('open_discount');
        }
      }, 2000); // 2-second delay
      
    } else {
      console.log('📝 No open_discount setting found, skipping auto-open');
    }
    
  } catch (error) {
    console.error('❌ Error checking open_discount setting:', error);
  }
}
